import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const COMMON_DOMAINS = ['gmail.com', 'yahoo.com', 'outlook.com', 'aol.com', 'hotmail.com', 'msn.com', 'live.com'];

const EmailAutocompleteTextField = (props) => {
  const { value, onChange, ...otherProps } = props;
  const [suggestions, setSuggestions] = React.useState([]);

  const handleInputChange = (event, newValue) => {
    // Ensure newValue is always a string
    const safeValue = newValue || '';
    
    // This calls the parent's handleChange to update the form state
    if (onChange) {
      // Call onChange with just the value directly (maid onboarding pattern)
      // The component is designed to work with direct value passing
      onChange(safeValue);
    }

    if (safeValue && typeof safeValue === 'string' && safeValue.includes('@')) {
      const parts = safeValue.split('@');
      const name = parts[0];
      const domainInput = parts[1];

      if (name && typeof domainInput === 'string') {
        const filteredDomains = COMMON_DOMAINS.filter(domain => 
          domain.toLowerCase().startsWith(domainInput.toLowerCase())
        );
        setSuggestions(filteredDomains.map(domain => `${name}@${domain}`));
      } else {
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  };

  return (
    <Autocomplete
      freeSolo
      autoSelect
      options={suggestions}
      inputValue={value || ''}
      onInputChange={handleInputChange}
      renderInput={(params) => (
        <TextField 
          {...params}
          {...otherProps}
        />
      )}
    />
  );
};

export default EmailAutocompleteTextField; 